<div
  id="toast-container"
  class="toast-{{ toastPosition }}"
  [hidden]="!showToast"
>
  <div
    [class]="'toast ' + type"
    aria-live="polite"
    style="display: block; opacity: 0.7"
  >
    <div
      class="toast-progress-bar"
      style="--animation-duration: {{ animationDuration }}"
    ></div>
    <button type="button" class="toast-close-button" (click)="closeToast()">
      x
    </button>
    <div class="toast-title">{{ header }}</div>

    <div class="toast-message" style="white-space: pre-line">
      {{ message }}
    </div>
  </div>
</div>
